import React from 'react';
import {useIntl} from 'react-intl';
import {SelectCustomerPopupContextProvider, useSelectCustomerPopupContext} from '../../contexts/SelectCustomerPopupContext';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import ModalPopup from '../../../../common/components/ui/ModalPopup';
import SelectCustomerWidget from '../SelectCustomerWidget';
import styles from './SelectCustomerPopupButton.module.scss';

const SelectCustomerPopupButtonComponent = () => {
  const intl = useIntl();
  const buttonText = intl.formatMessage({
    id: 'orderInvoice-modal-search-customers-button',
    defaultMessage: 'Select existing customer'
  });
  const {open, openPopup, closePopup, loading} = useSelectCustomerPopupContext();

  return (
    <>
      <ButtonAction
        variant={'link'}
        label={buttonText}
        onClick={openPopup}
        disabled={loading}
        customClassnames={{container: styles.triggerButton}}
      />
      <ModalPopup
        isOpen={open}
        onRequestClose={closePopup}
        customModalStyles={styles.modal}
      >
        <SelectCustomerWidget onCloseClicked={closePopup}/>
      </ModalPopup>
    </>
  );
};

const SelectCustomerPopupButton = () => {
  return (
    <SelectCustomerPopupContextProvider>
      <SelectCustomerPopupButtonComponent/>
    </SelectCustomerPopupContextProvider>
  );
};

export default SelectCustomerPopupButton;
